<template>
  <ViewLoader v-if="loading"/>

  <section class="checkout-section-wrapper" v-else>
    <CheckoutSuccess v-if="orderId" :order-id="orderId"/>

    <template v-else-if="cartDigitalItems.length > 0">
      <ModalVoucher :checkinId="voucherCheckinId" @voucher-redeemed="$store.dispatch('cart/getCart')"/>
      <ViewHeader class="d-none d-lg-block">
        <template #title>{{ $t('pages.checkout.page_title') }}</template>
        <template #intro>{{ $t('pages.checkout.page_subtitle') }}</template>
      </ViewHeader>

      <div class="container view-body view-body--padded">
        <div class="row pb-lg-8">
          <template>
            <section class="col-lg-8">
              <DigitalItems v-if="cartDigitalItems && cartDigitalItems.length > 0"/>
            </section>

            <section class="col-lg-4">
              <CheckoutSummary @pay-clicked="checkout($event)"/>

              <CheckoutStripeCard modalId="checkout-paywithcard"
                                  v-on:order-success="orderId = $event"/>

              <CheckoutStripeIdeal modalId="checkout-paywithideal"
                                   v-on:order-success="orderId = $event"/>

              <CheckoutStripeP24 modalId="checkout-paywithp24"
                                 v-on:order-success="orderId = $event"/>


              <CheckoutMercadoPago modalId="checkout-paywithmercadopago"
                                   :payment-settings="paymentSettingsMercadoPago"
                                   v-on:order-success="orderId = $event"/>

              <CheckoutPayWithBankTransfer modalId="checkout-paywithbanktransfer"
                                           v-on:order-success="orderId = $event"
                                           ref="paywithbanktransfer"/>


            </section>

          </template>
        </div>
      </div>
    </template>


    <CheckoutEmptyCart v-else/>

  </section>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {
  PAYMENT_METHOD_CARD,
  PAYMENT_METHOD_BANK_TRANSFER,
  PAYMENT_METHOD_IDEAL,
  PAYMENT_METHOD_MERCADO_PAGO,
  PAYMENT_METHOD_P24
} from "@/consts.js"

import ViewHeader from '@/components/ViewHeader'
import CheckoutEmptyCart from "@/components/CheckoutEmptyCart"
import CheckoutSummary from "@/domain/checkout/CheckoutSummary.vue"
import CheckoutStripeCard from "@/components/CheckoutStripeCard"
import CheckoutPayWithBankTransfer from "@/components/CheckoutPayWithBankTransfer"
import ViewLoader from "@/components/ViewLoader"
import ModalVoucher from "@/components/ModalVoucher"
import CheckoutSuccess from "@/views/CheckoutSuccess"
import CheckoutStripeIdeal from "@/components/CheckoutStripeIdeal";
import CheckoutMercadoPago from "@/components/CheckoutMercadoPago";
import CheckoutStripeP24 from "@/components/CheckoutStripeP24.vue";
import DigitalItems from "@/domain/cart/DigitalItems.vue";

export default {
  components: {
    DigitalItems,
    CheckoutStripeP24,
    CheckoutMercadoPago,
    CheckoutStripeIdeal,
    ViewLoader,
    ViewHeader,
    ModalVoucher,
    CheckoutEmptyCart,
    CheckoutSummary,
    CheckoutStripeCard,
    CheckoutPayWithBankTransfer,
    CheckoutSuccess,
  },

  data() {
    return {
      loading: true,
      isMobileOpen: false,
      orderId: null,
      voucherCheckinId: null,
    }
  },

  async mounted() {
    await this.fetchDigitalItems({includeMedia: true})
    await this.fetchPayments()
    await this.fetchTotalCartItems()
    this.loading = false
  },

  computed: {
    ...mapGetters('cartDigitalItems', [
      'cartDigitalItems',
      'paymentMethods',
      'paymentSettings',
      'totalCartItems',
      'cartDigitalItemsTotals'
    ]),
    paymentSettingsMercadoPago() {
      return this.paymentSettings[PAYMENT_METHOD_MERCADO_PAGO]
    },
  },

  methods: {
    ...mapMutations('cartDigitalItems', ['resetCart']),
    ...mapActions('cartDigitalItems', [
      'fetchDigitalItems',
      'fetchPayments',
      'fetchTotalCartItems'
    ]),
    PAYMENT_METHOD_MERCADO_PAGO() {
      return PAYMENT_METHOD_MERCADO_PAGO
    },
    async checkout(paymentMethodSelected) {

      if (paymentMethodSelected === null) {
        this.loading = true
        this.$store.dispatch("cart/placeOrder", {paymentMethod: null})
            .then(response => {
              this.loading = false
              this.orderId = response.data.id
              this.resetCart()
            })
            .catch(function (error) {
              console.log('ZERO-AMOUNT ERROR', error)
            })
      } else if (paymentMethodSelected === PAYMENT_METHOD_CARD) {
        this.$bvModal.show('checkout-paywithcard')
      } else if (paymentMethodSelected === PAYMENT_METHOD_IDEAL) {
        this.$bvModal.show('checkout-paywithideal')
      } else if (paymentMethodSelected === PAYMENT_METHOD_MERCADO_PAGO) {
        this.$bvModal.show('checkout-paywithmercadopago')
      } else if (paymentMethodSelected === PAYMENT_METHOD_P24) {
        this.$bvModal.show('checkout-paywithp24')
      } else if (paymentMethodSelected === PAYMENT_METHOD_BANK_TRANSFER) {
        this.$refs.paywithbanktransfer.showAndPay()
      }
    },

    openModalVoucher(checkinId) {
      this.voucherCheckinId = checkinId
      this.$bvModal.show('modal-voucher')
      this.$store.dispatch('cart/getCart')
          .then(() => {
          })
    }
  }
}
</script>
